import React from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Button from '@mui/material/Button';
import { EventList } from './EventList.Component';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import FilterListIcon from '@mui/icons-material/FilterList';
import { EventFilterComponent } from './EventFilterComponent';
import { CustomizedSnackbars } from '../../common/snackbars';
import format from 'date-fns/format';
import { GetConfig } from '../../../redux/middleware/configMiddleware';

export const EventComponent = (props) => {
   const nameFormat = GetConfig('name_format');
   function TabPanel(props) {
      const { children, value, index, ...other } = props;
      return (
         <Typography
            component="div"
            role="tabpanel"
            className="tab-panel"
            hidden={value !== index}
            {...other}
         >
            {children}
         </Typography>
      );
   }
   // Tabs
   const tabs = [];
   if (props.MyView) tabs.push('my');
   if (props.ReviewView) tabs.push('review');
   if (props.AllView) tabs.push('all');
   let currentTab = props.Tab;
   if (!tabs.includes(currentTab)) {
      currentTab = tabs[0];
   }
   const tabIndex = tabs.indexOf(currentTab);

   return (
      <React.Fragment>
         <div className={'section-main'}>
            <div className={'section-header'}>
               <div className={'col-left'}>
                  <Typography component="h2" className={'section-title'} variant="button" display="block" gutterBottom color="primary">
                     Event Requests
                  </Typography>
               </div>
               <div className={'st-timeEntry_payperiod-title center'}>
                  <span className={'label'}> Period</span>
                  {format(props.PeriodStartDate, 'MM/dd/yy')} - {format(props.PeriodEndDate, 'MM/dd/yy')}
               </div>
               <div className={'action'}>
                {props.EditView &&
                    <Button variant="contained" color="primary" size="small" onClick={()=>props.CreateEvent(0)}> New Request </Button>
                }
                  <Tooltip title="Filter">
                     <IconButton
                      onClick={props.FilterView(true)}
                     >
                        <FilterListIcon color="action" />
                     </IconButton>
                  </Tooltip>
                  <Drawer open={props.FilterViewState} anchor={'right'} onClose={props.FilterView(false)} >
                     <div className={'tree-view-drawer'}>
                        <div className={'drawer-title'}>Filter</div>
                        <EventFilterComponent props={props} saveFilter={props.SaveFilter} NameFormat={nameFormat} handleOnSubmit={props.FilterSubmit} HandleOnChange={props.HandleOnChange} handleStartDateChange={props.handleStartDateChange} handleEndDateChange={props.handleEndDateChange} HandleTreeChange={props.HandleTreeChange} ResetFilter={props.ResetFilter}  />
                     </div>
                  </Drawer>
               </div>
            </div>
            <div className={'section-body'}>
               <Paper>

                  <div className={'tab-navContainer d-flex justify-between steps-tab'}>
                     <Tabs
                        value={tabIndex}
                        onChange={(event, value) => {
                           const selectedTab = tabs[value];
                           props.onTabChange(selectedTab);
                        }}
                        indicatorColor="primary"
                        aria-label="Event Tabs"
                     >
                        {props.MyView && <Tab label="My Requests" />}
                        {props.ReviewView &&
                           <Tab
                              label={parseInt(props.ReviewCount) !== 0
                                 ? <Badge color="secondary" badgeContent={props.ReviewCount}>Review</Badge>
                                 : "Review"}
                           />}
                        {props.AllView && <Tab label="All Requests" />}
                     </Tabs>

                  </div>
                  <div className={'tab-panelContainer'}>
                     {tabs.map((tab, index) => (
                        <TabPanel key={tab} value={tabIndex} index={index}>
                           {tab === 'my' && props.MyView &&
                              <EventList
                                 NameFormat={nameFormat}
                                 Requests={props.Requests}
                                 CreateEvent={props.CreateEvent}
                                 HandleEditClick={props.HandleEditClick}
                                 HandleViewClick={props.ViewEvent}
                                 EditPermission={props.EditView}
                                 Tab={'my'}
                                 Logged_user={props.Logged_user}
                              />
                           }
                           {tab === 'review' && props.ReviewView &&
                              <EventList
                                 NameFormat={nameFormat}
                                 Requests={props.ReviewRequests}
                                 HandleViewClick={props.ViewEvent}
                                 ViewStaffDetails ={props.ViewStaffDetails}
                                 Tab={'review'}
                                 Logged_user={props.Logged_user}
                              />
                           }
                           {tab === 'all' && props.AllView &&
                              <EventList
                                 NameFormat={nameFormat}
                                 Requests={props.AllRequests}
                                 HandleViewClick={props.ViewEvent}
                                 ViewStaffDetails ={props.ViewStaffDetails}
                                 Tab={'all'}
                                 Logged_user={props.Logged_user}
                              />
                           }
                        </TabPanel>
                     ))}
                  </div>

               </Paper>
            </div>
         </div>
         {props.SnackbarOpen &&
            <CustomizedSnackbars
               open={props.SnackbarOpen}
               variant='success'
               message={props.SnackbarMsg}
               handleClose={props.SnackbarClose}
            />
         }

      </React.Fragment>
   )
};      
